import Header from '../../components/Header'
import Footer from '../../components/Footer'
import Error from '../../components/Error'

function ErrorPage() {
    return (
        <div>
            <Header></Header>
            <Error></Error>
            <Footer></Footer>
        </div>
    )
}

export default ErrorPage